import React, { Component } from 'react';
import { InfoLabel, Loader, Button } from '../../../common/components';
import { Row, Col } from 'react-bootstrap';
import { join } from 'lodash';
import { Link } from 'react-router';
import { InternalButtonBar } from '../../layout/components/InternalButtonBar/InternalButtonBar';

class ChannelDetails extends Component {
  render() {
    const { channel, broker } = this.props;

    if (!channel) {
      return <Loader />;
    }

    return (
      <div>
        <h4 className="title-campaign">Channel Details</h4>
        <hr id="first-row" />
        <Row>
          <Col sm={6}>
            <InfoLabel label="Name:" labelSize={4} value={channel.name} />
          </Col>
          <Col sm={6}>
            <InfoLabel label="Channel Type:" labelSize={4} value={channel.channel_type} />
          </Col>
          <Col sm={6}>
            <InfoLabel label="Key:" labelSize={4} value={channel.key} />
          </Col>
          <Col sm={6}>
            <InfoLabel label="Status:" labelSize={4} value={channel.status} />
          </Col>
          <Col sm={6}>
            <InfoLabel
              label="White Label:"
              labelSize={4}
              value={channel.whitelabel ? 'Yes' : 'No'}
            />
          </Col>
          <Col sm={6}>
            <InfoLabel
              label="Payment Types:"
              labelSize={4}
              value={channel.metadata ? join(channel.metadata.payment_types, ', ') : ''}
            />
          </Col>
          <Col sm={6}>
            <InfoLabel
              label="URL:"
              labelSize={4}
              value={
                <Link to={channel.url} target="_blank">
                  {channel.url}
                </Link>
              }
            />
          </Col>
          {channel.metadata && channel.metadata.content && (
            <div>
              <Col sm={6}>
                <InfoLabel
                  label="Opening Hours:"
                  labelSize={4}
                  value={channel.metadata.content.opening_hours || ''}
                />
              </Col>
              <Col sm={6}>
                <InfoLabel
                  label="Phone:"
                  labelSize={4}
                  value={channel.metadata.content.telephone_number || ''}
                />
              </Col>
              <Col sm={12}>
                <InfoLabel
                  label="Footer:"
                  labelSize={2}
                  value={channel.metadata.content.footer || ''}
                />
              </Col>
            </div>
          )}
        </Row>
        {broker.data && broker.data.id && (
          <Row>
            <Col xs={12}>
              <InternalButtonBar
                buttons={[
                  {
                    permissions: ['broker.view'],
                    button: (
                      <Button
                        label="View Broker"
                        className="pull-right"
                        bsStyle="primary"
                        link
                        to={'/admin/brokers/' + broker.data.id}
                      />
                    ),
                  },
                ]}
              />
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

export default ChannelDetails;
